var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status",class:[_vm.status.toLowerCase(), _vm.objectType]},[_c('font-awesome-icon',{attrs:{"icon":_vm.iconName}}),_vm._v("\n  "+_vm._s(_vm.$t(("statuses." + (_vm.status.toLowerCase()))))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }